import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Section } from '../overview/model/overview.model';

export const AccordionSearchActions = createActionGroup({
  source: 'Accordion Search',
  events: {
    'Load Sections': emptyProps(),
    'Set Sections': props<{ sections: Section[] }>(),
    'Toggle Section': props<{ id: string }>(),
    'Collapse All': emptyProps(),
    'Expand All': emptyProps(),
    'Toggle Section Filtered': props<{ id: string }>(),
    'Collapse All Filtered': emptyProps(),
    'Expand All Filtered': emptyProps(),
  },
});
